<template>
  <div class="my_color_layer">
    <p :class="type === 'one_level' ? 'set_one_level' : 'set_two_level'">
      <span v-text="title" class="title" :style="{ width: titleWidth + 'px' }"></span>
      <span
        class="color_block module"
        :class="my_color === 'rgba(254,254,254,0)' ? 'color_block_transparent' : ''"
        @click="picker_open"
        :style="{ background: my_Pattern === 'linear_gradient' ? 'linear-gradient('+my_linear_gradient.deg + 'deg,' +my_linear_gradient.start_color + ' ' + my_linear_gradient.start_pointer + '%,' + my_linear_gradient.end_color + ' ' + my_linear_gradient.end_pointer +'%)' : my_color }"
      ></span>
    </p>
  </div>

</template>

<script>
import i18n from '../../language/index'

  /*
  * linear_gradient 文字渐变对象
  * color纯色色值
  * title组件标题
  *pattern pure_color 纯色   linear_gradient 渐变
  * */

  export default {
    name: "my_color_picker",
    props: {
      titleWidth: {
        type: String,
        default: '40'
      },
      color: {
        type: String,
        default: 'rgb(252, 192, 46,1)'
      },
      pattern: {
        type: String,
      },
      linear_gradient: {
        type: Object,
      },
      title: { // 组件的标题
        type: String,
        default: i18n.t('base_colorschemedesigner_629')
      },
      type: { // 组件的类型  one_level 一级组件 two_level 二级组件
        type: String,
        default: 'two_level'
      },
    },
    data() {
      return {
        picker_is_show: false,
        my_color: this.color,
        my_Pattern: this.pattern,
        my_linear_gradient: this.linear_gradient
      }
    },
    watch: {
      my_color(val) {
        this.$emit('update:color', val)
        this.$emit('change', val)
      },
      my_linear_gradient: {
        handler: function (val) {
          this.$emit('update:linear_gradient', val)
        },
        deep: true
      },
      linear_gradient: {
        handler: function (val) {
          this.my_linear_gradient = val
        },
        deep: true
      },
      color(val) {
        this.my_color = val
      },
      pattern(val) {
        this.my_Pattern = val
      },
      my_Pattern(val) {
        this.$emit('update:pattern', val)
      },
    },
    components: {},
    methods: {
      hexToRgb(hex) {
        var reg = /^[0-9a-zA-Z]$/;
        let r = '';
        if (!reg.test(hex) && hex.length == 6) {
          r = "rgb(" + parseInt("0x" + hex.slice(0, 2)) + "," + parseInt("0x" + hex.slice(2, 4)) + "," + parseInt("0x" + hex.slice(4, 6)) + ")";
        }
        return r;
      },
      picker_open(e) {

        this.$store.commit('color/select_color_change', this.my_color);
        this.$store.commit('color/set_Pattern', this.my_Pattern);
        this.$store.commit('color/set_linear_gradient', this.my_linear_gradient);
        this.$store.commit('color/isShow_change', true);

        let left =  e.clientX + 15
        let top = e.clientY - 90
        this.$nextTick(()=>{
          // 颜色选择器可能显示不完整
          let screenHeight = $(window).height()
          let colorPickerHeight = $('.my_picker').height()
          if(top+colorPickerHeight>screenHeight){
            top = screenHeight - colorPickerHeight - 35
          }
          this.$store.commit('color/set_position', {
            left,
            top,
          });
        })

        this.$store.commit('color/set_color_change', (data) => {
          if (data.Pattern) {
            this.my_Pattern = data.Pattern;
          }
          if (data.select_color) {
            this.my_color = data.select_color;
          }
          if (data.linear_gradient) {
            this.my_linear_gradient = data.linear_gradient;
          }

        });
      },

    }
  }
</script>

<style scoped lang="scss">
  .color_block {
    box-sizing: border-box;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    overflow: hidden;
    cursor: pointer;
    background: #f00;
    margin-top: 6px;
    border: 1px solid #d8d8d8;
  }
  .color_block_transparent{
    position: relative;
  }
  .color_block_transparent::before{
        content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: white;
  }
.color_block_transparent::after{
  content: "";
    position: absolute;
    top: 100%;
    left: 0;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    width: 22px;
    height: 1px;
    background: red;
}

</style>



// WEBPACK FOOTER //
// src/components/my_color/index.vue